import React from "react";

const Fee = () => {
   return(<h1>This is Fee</h1>);
};
export default Fee;